import { WprValueMapSetter } from '../../../wpr-framework/model/WprValueMapSetter';
import { WprValueMap } from '../../../wpr-framework/model/WprValueMap';

/**
 * 日付バリューマップ
 */
export class DateValueMap {
	// static メソッド  --------------------------------------------------------
	/**
	 * ValueMap設定処理
	 * @param vmSetter ValueMapセッター
	 */
	public static addValueMap(vmSetter: WprValueMapSetter): void {
		const now = new Date();
		let vm = new WprValueMap();
		for (let i = 1900; i <= now.getFullYear(); i++) {
			vm.addValue(i, `${i}`);
		}
		vmSetter.addValueMap('year', vm);
		vm = new WprValueMap();
		for (let i = 1; i <= 12; i++) {
			vm.addValue(i, `${i}`);
		}
		vmSetter.addValueMap('month', vm);
		vm = new WprValueMap();
		for (let i = 1; i <= 31; i++) {
			vm.addValue(i, `${i}`);
		}
		vmSetter.addValueMap('date', vm);
	}
	// -------------------------------------------------------------------------
}